<template>
  <div class="my-container">
    <div class="row riga non-mobile font-weight-bold">
      <div class="col-md-2 col-6">
        <p>{{ trans.get("b2b.documents.doc") }}</p>
      </div>
      <div class="col-md-2 col-6">
        <p>{{ trans.get("b2b.documents.doc-type") }}</p>
      </div>
      <div class="col-md-2 col-6">
        <p>{{ trans.get("b2b.documents.doc-date") }}</p>
      </div>
      <div class="col-md-2 col-6 text-right">
        <p>{{ trans.get("b2b.documents.price") }}</p>
      </div>
      <div class="col-md-2 col-6 text-right">
        <p>{{ trans.get("b2b.documents.vat") }}</p>
      </div>
    </div>
    <div
      class="row pointer riga"
      v-for="(doc, i) in noDocs"
      :key="i"
      v-if="loaded"
      :class="!(i % 2) ? 'dispari' : ''"
    >
      <div class="col-md-2 col-6 mobile">
        <p>
          <b>{{ trans.get("b2b.documents.doc") }}</b>
        </p>
      </div>

      <div class="col-md-2 col-6">
        <p>{{ doc.idDocumento }}</p>
      </div>

      <div class="col-md-2 col-6 mobile mob-invisible">
        <p>
          <b>{{ trans.get("b2b.documents.doc-type") }}</b>
        </p>
      </div>

      <div class="col-md-2 col-6 mob-invisible">
        <p>{{ transDescription(doc.desClasseDoc) }}</p>
      </div>

      <div class="col-md-2 col-6 mobile mob-invisible">
        <p>
          <b>{{ trans.get("b2b.documents.doc-date") }}</b>
        </p>
      </div>

      <div class="col-md-2 col-6 mob-invisible">
        <p>{{ parseDate(doc.dataConsegna) }}</p>
      </div>

      <div class="col-md-2 col-6 mobile mob-invisible">
        <p>
          <b>{{ trans.get("b2b.documents.price") }}</b>
        </p>
      </div>

      <div class="col-md-2 col-6 desk-text-right mob-invisible">
        <p>{{ doc.totDoc.toLocaleString('it-IT', {minimumFractionDigits: 3}) }} €</p>
      </div>

      <div class="col-md-2 col-6 mobile mob-invisible">
        <p>
          <b>{{ trans.get("b2b.documents.vat") }}</b>
        </p>
      </div>

      <div class="col-md-2 col-6 desk-text-right mob-invisible">
        <p>{{ doc.totIvaDoc.toLocaleString('it-IT', {minimumFractionDigits: 3}) }} €</p>
      </div>
      <div class="col-md-2 mob-invisible">
        <a
          v-if="doc.idPdf !== 0 && doc.versPdf !== 0"
          @click="getPdf(doc)"
          >{{ trans.get("b2b.documents.pdf") }}</a
        >
        <a @click="getPdfOrdine(doc.idDocumento)" v-if="doc.tipoDocumento === '100'">{{ trans.get("b2b.documents.pdf") }}</a>
      </div>
    </div>
    <b-skeleton size="is-large" height="100px" :active="!loaded"></b-skeleton>
  </div>
</template>

<script>
export default {
  name: "documenti",
  data() {
    return {
      docs: null,
      noDocs: null,
      loaded: false,
      link: true,
    };
  },
  mounted() {
    this.getDocumenti();
  },
  computed: {},
  methods: {
    alertCustomError(msg) {
      this.$buefy.dialog.alert({
        title: this.$trans('b2b.documents.error'),
        message: msg,
        type: 'is-danger',
        hasIcon: true,
        icon: 'times-circle',
        iconPack: 'fa',
        ariaRole: 'alertdialog',
        ariaModal: true
      })
    },
    getPdfOrdine(id_doc){
      //console.log(id_doc)
      axios({
        method: 'get',
        url: window.location.origin + '/b2b/downloadPdfOrdine',
        params: {
          id_doc: id_doc
        }
      }).then(res => {
        if (res.data[0]) {
          let link = document.createElement("a");
          document.body.appendChild(link);
          link.setAttribute("type", "hidden");
          // settaggio dell'href (in questo caso il base64, non è un link) + nome del file (abbiamo inserito il datetime nel nome dell'esportazione)
          link.href = window.location.origin + '/storage/ordini/Ordine_' + res.data + '.pdf';
          // simulo il click nel link + rimozione del link ad operazione conclusa 2021-20001-112
          link.download = 'Ordine_' + res.data + '.pdf'
          link.click();
          document.body.removeChild(link);
        }else {
          this.alertCustomError(this.$trans('b2b.documents.doc-notfound'))
        }
      }).catch(err => {
        console.log(err.response.data.message)
      })
    },
    transDescription(t){
      switch (t){
        case 'Ordine da cliente':
          return this.$trans('b2b.documents.order')
        case 'Fattura cliente':
          return this.$trans('b2b.documents.invoice')
        case 'Nota credito a cliente':
          return  this.$trans('b2b.documents.credit-note')
      }
    },
    getPdf: function (doc) {

      axios({
        method: "get",
        url: window.location.origin + "/b2b/downloadPdf",
        params: {
          idPdf: doc.idPdf,
          versione: doc.versPdf,
        },
      })
        .then((res) => {
          //window.open(window.location.origin + res.data, "_blank");
          if (res.data) {
            let link = document.createElement("a");
            document.body.appendChild(link);
            link.setAttribute("type", "hidden");
            // settaggio dell'href (in questo caso il base64, non è un link) + nome del file (abbiamo inserito il datetime nel nome dell'esportazione)
            link.href = "data:application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;base64," + res.data;
            link.download = doc.dataRegistrazione.split('-')[0]+'-'+doc.codSerie+'-'+doc.numRegistraz +'-'+ doc.versPdf + '.pdf';
            // simulo il click nel link + rimozione del link ad operazione conclusa 2021-20001-112
            link.click();
            document.body.removeChild(link);

          }
        })
        .catch((err) => {
          console.log(err.response.message);
        });
    },
    parseDate: function (data) {
      let newData = dayjs(data);
      let anno = newData.year();
      let mese = newData.month() + 1;
      let giorno = newData.date();
      return `${giorno}-${mese}-${anno}`;
    },
    noOrdini: function () {
      this.noDocs = this.docs.filter((item) => item.tipoDocumento !== "701");
    },
    getDocumenti: function () {
      axios({
        method: "get",
        url: window.location.origin + "/b2b/getDocumenti",
      }).then((res) => {
        this.docs = res.data;
        this.noOrdini();
        this.loaded = true;
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.desk-text-right {
  text-align: left;
}
.my-container {
  width: 80%;
  margin: 0 auto;
}
.riga {
  margin: 10px auto !important;
  padding: 10px 0;
  .mob-invisible {
    display: none;
  }
  &:hover {
    .mob-invisible {
      //display: block;
    }
    p {
      font-weight: bold;
    }
  }

  &.dispari {
    background-color: #f8f7f7 !important;
  }
}
.row {
  background-color: #eee;
  margin: 10px 0;
}
.mobile {
  display: block;
}
.non-mobile {
  display: none;
}

@media (min-width: 768px) {
  .riga {
    .mob-invisible {
      display: block;
    }
    .mobile {
      display: none;
    }
  }
  .non-mobile {
    display: flex;
  }
  .desk-text-right {
    text-align: right;
  }

  .row {
    background-color: inherit;
    margin: 0;
  }
}
</style>
